function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  fill: "#2C2B6C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0558 8.2643C18.9303 8.39333 18.724 8.39622 18.595 8.27075C18.466 8.14529 18.4631 7.93898 18.5885 7.80995L19.4972 6.87544C19.6227 6.74641 19.829 6.74352 19.958 6.86899C20.087 6.99445 20.0899 7.20076 19.9645 7.32979L19.0558 8.2643Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.8657,
  cy: 11.3656,
  r: 2.60693,
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 15.5396,
  y: 5.5,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 11.5082,
  y: 7.37183,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  transform: "rotate(-46.3259 11.5082 7.37183)",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7957 14.3155C18.6583 14.1992 18.6412 13.9936 18.7575 13.8562C18.8737 13.7189 19.0793 13.7017 19.2167 13.818L20.2117 14.6601C20.3491 14.7763 20.3662 14.982 20.2499 15.1193C20.1336 15.2567 19.928 15.2738 19.7906 15.1576L18.7957 14.3155Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 11.9552,
  y: 11.3656,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  transform: "rotate(90 11.9552 11.3656)",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 21.7312,
  y: 11.0397,
  width: 0.651733,
  height: 1.9552,
  rx: 0.325867,
  transform: "rotate(90 21.7312 11.0397)",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.78482 20.4324H18.8593C19.6377 20.4324 20.2553 20.0086 20.6612 19.475C21.0636 18.946 21.2831 18.2778 21.246 17.7259C21.2085 17.1684 20.8957 16.5826 20.4306 16.1476C20.0084 15.7528 19.4418 15.4644 18.8014 15.4376C18.6505 14.7743 18.4901 14.3541 18.2734 14.0318C18.062 13.7174 17.8032 13.5092 17.5045 13.2689C17.4695 13.2406 17.4339 13.212 17.3977 13.1827C17.0106 12.8687 16.613 12.687 16.1662 12.6237C15.7751 12.5683 15.3595 12.6056 14.8985 12.7069C14.3408 11.8392 13.5064 11.3073 12.6601 11.0733C11.7697 10.8272 10.8369 10.9038 10.181 11.3011C9.58056 11.6649 9.06277 12.0885 8.69557 12.6259C8.36867 13.1043 8.16822 13.6625 8.12604 14.3283C6.46287 14.2784 4.75 15.5551 4.75 17.4858C4.75 18.5219 5.3298 19.2631 5.97826 19.7345C6.6176 20.1993 7.36412 20.4324 7.78482 20.4324Z",
  fill: "white",
  stroke: "#2C2B6C",
  strokeWidth: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 12.5,
  stroke: "white",
  strokeWidth: 2
});

function SvgWeatherTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherTooltip);
export default __webpack_public_path__ + "static/media/weather-tooltip.5a088792.svg";
export { ForwardRef as ReactComponent };